module.exports = __webpack_public_path__ + "img/logo_small.f48f8c74.png";